// Central manifest of past-show photography woven into the site's design.
// These are used across the site as pastel backdrops, watermarks, filmstrips,
// and full-color spotlights. All photos are courtesy of Encore productions.

export const SHOW_PHOTOS = [
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_encore-restore/artifacts/yr8pv7qq_IMG_5788.webp",
    alt: "Actor in a shimmering checkered suit beside a leading lady in emerald and fur — Encore production",
    orientation: "landscape",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_encore-restore/artifacts/b1cam9qz_IMG_5789.webp",
    alt: "Two performers on stage in green and violet coats, a lifted-hat moment",
    orientation: "landscape",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_encore-restore/artifacts/eo0q7nvg_IMG_5790.webp",
    alt: "A tender embrace between two performers in a warm blue interior",
    orientation: "landscape",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_encore-restore/artifacts/u5ybvs4i_IMG_5791.webp",
    alt: "Leading actor in vest and tie, mid-scene, with a teal curtain backdrop",
    orientation: "landscape",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_encore-restore/artifacts/78yugsuu_IMG_5792.webp",
    alt: "Solo performer under a blue-lit skid-row alley set piece",
    orientation: "portrait",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_encore-restore/artifacts/e1fq2tim_IMG_5793.webp",
    alt: "Three women mid-song, dancing in front of Mushnik's flower shop",
    orientation: "landscape",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_encore-restore/artifacts/1qdervvq_IMG_5794.webp",
    alt: "Actor in Audrey II leaf-puppet, hands raised — a Little Shop of Horrors moment",
    orientation: "portrait",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_encore-restore/artifacts/7lvegmg0_IMG_5795.jpeg",
    alt: "Athlete in silhouette raising a football helmet under stadium lights",
    orientation: "portrait",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_encore-restore/artifacts/sp3x7pe4_IMG_5796.jpeg",
    alt: "Black and white portrait of a quarterback in prayerful pose before the snap",
    orientation: "portrait",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_encore-restore/artifacts/0xmupexp_IMG_5797.jpeg",
    alt: "Black and white portrait of a matriarchal figure in a woven shawl, mid-monologue",
    orientation: "portrait",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_encore-restore/artifacts/cxl30jba_IMG_5798.webp",
    alt: "Two performers by a brick wall — trench coat and puffer, a moment of quiet tension",
    orientation: "landscape",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_encore-restore/artifacts/x7boylnw_IMG_5799.jpeg",
    alt: "Soldier in fatigues on stage against exposed brick — coming-home scene",
    orientation: "landscape",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_encore-restore/artifacts/ewd1gl8p_IMG_5800.jpeg",
    alt: "Two supervisors in safety vests in a Detroit workroom set — Skeleton Crew moment",
    orientation: "landscape",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_encore-restore/artifacts/21e8w241_IMG_5801.webp",
    alt: "Bedroom scene with three actors mid-conversation, a family reckoning",
    orientation: "landscape",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_encore-restore/artifacts/tt6306h2_IMG_5802.jpeg",
    alt: "Two adults and a teenager against a comic-book courtroom backdrop",
    orientation: "landscape",
  },
  {
    src: "https://customer-assets-jt897jd0.emergentagent.net/job_encore-restore/artifacts/dvrphiwv_IMG_5803.jpeg",
    alt: "Three performers on a brownstone stoop, one in a sunflower dress, mid-scene",
    orientation: "landscape",
  },
];

// Convenience selections for common use
export const LANDSCAPE_PHOTOS = SHOW_PHOTOS.filter(
  (p) => p.orientation === "landscape"
);
export const PORTRAIT_PHOTOS = SHOW_PHOTOS.filter(
  (p) => p.orientation === "portrait"
);
